

















































































































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import moment from 'moment'
import RemuneracaoMedicaApi from '@/Apis/RemuneracaoMedica/Services/RemuneracaoMedicaApi'
import EventBus from '@/plugins/EventBus'
import useScrollArrowsTabela from '@/composables/useScrollArrowsTabela/useScrollArrowsTabela'
import { AgrupamentoRepasse, MoverItemAgrupamentoSelecao } from '@/types/interfaces/MoverItemAgrupamento'

@Component
export default class ModalDetalheAgrupamento extends Vue {
  @Prop({ required: true, default: false }) visible: boolean
  @Prop({ default: null }) agrupamentoId: string | null

  carregando = false
  detalhe: any = null

  scrollArrows = useScrollArrowsTabela(refName => this.getTabelaOverflow(refName))

  headersRepasses = [
    { text: 'Nº repasse', value: 'numeroRepasse', align: 'center', sortable: false },
    { text: 'Prestador', value: 'prestadorNome', sortable: false },
    { text: 'Empresa médica', value: 'empresaMedicaNome', sortable: false },
    { text: 'Fonte pagadora', value: 'fontePagadoraNome', sortable: false },
    { text: 'Nº nota', value: 'numeroNota', align: 'center', sortable: false },
    { text: 'Valor', value: 'valorNotaFiscal', align: 'center', sortable: false },
    { text: 'Situação', value: 'situacao', align: 'center', sortable: false },
    { text: 'Ações', value: 'acoes', align: 'center', sortable: false },
  ]

  headersHistorico = [
    { text: 'Quando', value: 'alteradoEm', align: 'center', sortable: false },
    { text: 'Por', value: 'alteradoPorNome', sortable: false },
    { text: 'De', value: 'numeroChamadoAnterior', align: 'center', sortable: false },
    { text: 'Para', value: 'numeroChamadoNovo', align: 'center', sortable: false },
  ]

  headersMovimentacao = [
    { text: 'Quando', value: 'alteradoEm', align: 'center', sortable: false },
    { text: 'Por', value: 'alteradoPorNome', sortable: false },
    { text: 'Repasse', value: 'numeroRepasse', align: 'center', sortable: false },
    { text: 'Chamado origem', value: 'numeroChamadoOrigem', align: 'center', sortable: false },
    { text: 'Chamado destino', value: 'numeroChamadoDestino', align: 'center', sortable: false },
  ]

  // Abrir outro agrupamento troca o id e a visibilidade no mesmo tick: um watcher só evita carregar duas vezes.
  get agrupamentoExibido() {
    return this.visible ? this.agrupamentoId : null
  }

  @Watch('agrupamentoExibido')
  onAgrupamentoExibidoChange(agrupamentoId: string | null) {
    if (agrupamentoId) this.carregarDetalhe()
  }

  async carregarDetalhe() {
    this.carregando = true
    this.detalhe = null
    try {
      const response: any = await RemuneracaoMedicaApi.getAgrupamentoDetalhe({ id: this.agrupamentoId })
      if (response.success) {
        this.detalhe = response.data
        this.$nextTick(() => {
          this.scrollArrows.anexar('tabelaRepasses')
          this.scrollArrows.anexar('tabelaHistoricoChamado')
          this.scrollArrows.anexar('tabelaHistoricoMovimentacao')
        })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao carregar detalhes.', icon: 'warning', color: '#C62828' })
      }
    } finally {
      this.carregando = false
    }
  }

  getTabelaOverflow(refName: string): HTMLElement | null {
    const tabela = this.$refs[refName] as Vue | undefined
    return tabela ? (tabela.$el as HTMLElement).querySelector('.v-table__overflow') : null
  }

  get arrowsState() {
    return this.scrollArrows.setas
  }

  scrollTable(refName: string, delta: number) {
    this.scrollArrows.rolar(refName, delta)
  }

  beforeDestroy() {
    this.scrollArrows.destruir()
  }

  formatarDataHora(value: string | null) {
    if (!value) return ''
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  formatarMesAno(value: string | null) {
    if (!value) return '-'
    return moment(value).format('MM/YYYY')
  }

  rotuloRpa(value: boolean | null | undefined) {
    if (value === null || value === undefined) return '-'
    return value ? 'Não' : 'Sim'
  }

  // O modal de mover abre na tela que hospeda este, nao aninhado: v-dialog dentro de v-dialog
  // fullscreen devolvia a rolagem da pagina ao fechar o de dentro.
  abrirMoverItem(repasse: AgrupamentoRepasse) {
    this.moverItem({ repasse, agrupamento: this.detalhe && this.detalhe.agrupamento })
  }

  getTooltipMoverItem(repasse: { situacaoRepasse: string }) {
    if (repasse.situacaoRepasse === 'Paga') {
      return 'Repasse já pago, não é possível mover'
    }

    return 'Mover o repasse para outro agrupamento'
  }

  @Emit('mover-item')
  moverItem(payload: MoverItemAgrupamentoSelecao) {
    return payload
  }

  @Emit('close')
  close() { }
}
